import { hcl } from "d3-color";

export function isDark(color) {
  const colorObj = hcl(color);
  return colorObj.l < 65;
}

export function darken(color) {
  return hcl(color)
    .darker(1)
    .formatHex();
}
